import { Bits, Notifier, Terminator } from "@opendaw/lib-std";
export class NoteStreamReceiver {
    #terminator = new Terminator();
    #receiver;
    #address;
    #bits;
    #notifier;
    constructor(receiver, address) {
        this.#receiver = receiver;
        this.#address = address;
        this.#bits = new Bits(128);
        this.#notifier = new Notifier();
        this.#terminator.own(this.#receiver.subscribeIntegers(this.#address, (array) => {
            if (this.#bits.replace(array.buffer)) {
                this.#notifier.notify(this);
            }
        }));
    }
    isNoteOn(note) { return this.#bits.getBit(note); }
    isAnyNoteOn() { return this.#bits.nonEmpty(); }
    subscribe(observer) { return this.#notifier.subscribe(observer); }
    terminate() { this.#terminator.terminate(); }
}
